import { tv } from 'tailwind-variants';

export const inputVariants = tv({
  base: `
    rounded-xl w-full bg-surface-2-v2 border border-surface-3 font-medium
    disabled:opacity-40 placeholder:text-surface-2-v2-contrast-subtle
    [&.ng-invalid.ng-dirty]:border-red-500/50 [&.ng-invalid.ng-dirty]:bg-red-500/10
    focus:ring-2 outline-none focus:ring-primary focus:border-transparent! select-none
  `,
  variants: {
    size: {
      sm: 'h-8 text-xs px-2',
      md: 'h-10 text-sm px-3',
      lg: 'h-12 px-4',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
